import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { ItemCardMultiPriceOptionDisplay } from "./item_card_price_option_display.js";
//#region src/item_card_price_option_display_helper.ts
var item_card_price_option_display_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(display) {
	switch (display) {
		case ItemCardMultiPriceOptionDisplay.PriceRange: return "Price Range";
		case ItemCardMultiPriceOptionDisplay.NameAndPrice: return "Each Name and Price";
		case ItemCardMultiPriceOptionDisplay.NameAndPriceCollapseMatching: return "Each Name and Price (Collapse Matching Prices)";
		case ItemCardMultiPriceOptionDisplay.FirstPriceOnly: return "First Price Only";
	}
}
//#endregion
export { item_card_price_option_display_helper_exports, name };

//# sourceMappingURL=item_card_price_option_display_helper.js.map